import { render, staticRenderFns } from "./PaymentStepExtra.vue?vue&type=template&id=ccb4e4bc&scoped=true&"
import script from "./PaymentStepExtra.vue?vue&type=script&lang=js&"
export * from "./PaymentStepExtra.vue?vue&type=script&lang=js&"
import style0 from "./PaymentStepExtra.vue?vue&type=style&index=0&id=ccb4e4bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb4e4bc",
  null
  
)

export default component.exports